import { createContext, ReactNode, useState } from "react";
import { safeLocalStorage } from "../utils/safeLocalStroage.ts";

// Define the types for the context value
interface CompactContextType {
  compact: boolean;
  toggleCompact: () => void;
}

function initCompact() {
  const compact = safeLocalStorage.getItem("compact");
  if (compact) return Boolean(JSON.parse(compact));
  return false;
}

// Create the context with default values
export const CompactContext = createContext<CompactContextType>({
  compact: false,
  toggleCompact: () => {
    console.warn("toggleCompact before init");
  },
});

interface CompactProviderProps {
  children: ReactNode;
}

export const CompactProvider = ({ children }: CompactProviderProps) => {
  const [compact, setCompact] = useState<boolean>(initCompact());
  const toggleCompact = () => {
    setCompact(!compact);
    safeLocalStorage.setItem("compact", JSON.stringify(!compact));
  };

  return (
    <CompactContext.Provider
      value={{
        compact: compact,
        toggleCompact: toggleCompact,
      }}
    >
      {children}
    </CompactContext.Provider>
  );
};
